import runtimeConfig from '~config/config';

import { NUU_HEADER_LOCATION_OVERRIDE, NUU_HEADER_RESPONSE_ID } from '~coreModules/core/js/constants';

const { apiUrls } = runtimeConfig;

/**
 * Gets a product's details by slug
 * @param {Object} options - Options object
 * @param {Object} options.r15Svc - r15 axios REST client instance
 * @param {String} options.productSlug - the product slug
 * @param {Object} options.params - the params to send to the service
 * @param {String} options.dcOverride - the id of the DC to use for inventory
 * @param {String} options.responseId - the responseId from the service call credited
 */
export function getProductDetails({
    r15Svc,
    productSlug,
    params = {},
    dcOverride = null,
    catalogResponseId = null,
}) {

    const options = {
        params: {
            excludeFromRecentlyViewed: false,
            ...params,
        },
        headers: {
            ...(dcOverride && { [NUU_HEADER_LOCATION_OVERRIDE]: dcOverride }),
            ...(catalogResponseId && { [NUU_HEADER_RESPONSE_ID]: catalogResponseId }),
        },
    };

    return r15Svc.get(`${apiUrls.productService}/slug/${productSlug}`, options);
}

export function getProductBySku(r15Svc, skuId) {
    return r15Svc.get(`${apiUrls.productService}/sku/${skuId}`);
}

/**
 * Retrieves a list of products given a list of choiceIds
 * @param {Array} choiceIds - list of product choiceIds
 * @return {Promise} - service request
 */
export function getProductsByChoiceId(r15Svc, choiceIds) {
    return r15Svc.get(`${apiUrls.productServiceURBNSearch}/choices/${choiceIds.join(',')}`);
}
